<template>
<div class="q-pa-md q-mx-auto" style="min-width: 350px">
  <h4 class="text-center">Medsafe Router</h4>
  <div class="flex justify-center">
    <q-btn
      push
      size="sm"
      type="reset"
      color="white"
      text-color="standard"
      :href='`https://esia.medsafe.tech/${hashLink}`'
      @click="setAppHash"
    >
      Войти через
      <img alt="gu-logo" width="100px" class="q-ml-xs" src="@/assets/logo-gosuslugi-ru.png">
    </q-btn>
  </div>

</div>
</template>

<script lang="ts">
import {
  defineComponent, reactive, ref, computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '~store/auth/authModule';
import * as crypto from 'crypto-js';
import { setCookie } from '@/utils/cookies';

export default defineComponent({
  setup() {
    const data = reactive({
      login: '',
      password: '',
    });
    const authStore = useAuthStore();
    const isLoading = ref(false);
    const isPwd = ref(true);

    const onSubmit = () => {
      authStore.signIn(data.login, data.password);
    };
    const onReset = () => {
      data.login = '';
      data.password = '';
    };

    const hashLink = computed(() => {
      const now = new Date();
      const date_str = (`0${now.getDate()}`).slice(-2) + (`0${now.getMonth() + 1}`).slice(-2) + now.getFullYear();
      const hash = crypto.SHA1(`medsafe.tech${date_str}`);
      const digestHex = hash.toString(crypto.enc.Hex);
      return digestHex;
    });

    const setAppHash = () => {
      setCookie('medsafe-tech-hash', hashLink.value, { secure: true, expires: 1 });
    };

    return {
      data,
      onSubmit,
      onReset,
      isPwd,
      setAppHash,
      hashLink,
    };
  },
});
</script>
